/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { IFunnelSpec } from '../../../../layer/preset/funnel/funnel';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';
import type { Data } from '../../specProcessor';

export type Spec = BaseSpec;

type FunnelLayerType = StandardChartLayerSpec & IFunnelSpec & ILayerTypeSpec;

// 创建漏斗图数据类型验证器
const validateFunnelDataTypes = createDataTypeValidator('funnel', [
  { field: 'x', type: 'string' },
  { field: 'y', type: 'number' }
]);

// 创建漏斗图编码验证器
const validateFunnelEncoding = createEncodingValidator([{ field: 'x' }, { field: 'y' }]);

// 额外的检查函数
const additionalFunnelChecks = (layer: FunnelLayerType, data: Data) => {
  // 检查数据数量是否满足要求
  const dataIndex = layer.dataIndex || 0;
  const values = data[dataIndex]?.values || [];
  if (values.length <= 1) {
    utils.logger.warn(
      'warning',
      'The funnel chart requires more than 1 data point to display properly'
    );
  }
};

// 创建并导出漏斗图处理器
export const funnel = createLayerProcessor<FunnelLayerType>(
  'funnel',
  validateFunnelEncoding,
  validateFunnelDataTypes,
  additionalFunnelChecks
);
